import React, { useEffect, useState } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import AciHighwayResponseApiUrls from 'src/apiUrls/AciHighwayResponseApiUrls'
import AciHighwayManifestKeys from 'src/constants/locale/key/AciHighwayManifest'
import AciHighwayKeys from 'src/constants/locale/key/AciHighwayResponse'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import ACIHighwayManifestTranslationText from 'src/views/acihighway/contexts/ACIHighwayManifestTranslationText'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function ManifestResponse(props) {
  const { showNotification, id, isViewOnly = false, manifestId, cargoPage } = props

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  const [data, setData] = useState([])
  const [lookups, setLookups] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const { fetchRecord, fetchRecords } = useServices()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const classes = useStyles()

  function getCargo() {
    return fetchRecord.execute(AciHighwayCargoApiUrls.GET, id, (res) => res.content[0])
  }

  function fetchManifestResponse(cargoManifestId) {
    return fetchRecords.execute(AciHighwayResponseApiUrls.GET,
      {
        filters: [
          {
            field: 'headerId',
            operator: 'equal',
            value: cargoManifestId ? cargoManifestId : (cargoPage ? manifestId : id)
          },
          {
            field: 'referenceIdentification',
            operator: 'in',
            value: ['TG', 'AQ-M', 'BD-M']
          },
          {
            field: 'docCode',
            operator: 'in',
            value: ['350', '824', '997']
          },
        ]
      }, (res) => res.content)
  }

  function showManifestResponse() {
    if (!cargoPage || (cargoPage && (manifestId != null && manifestId.length != 0))) {
      Promise.all([fetchManifestResponse()]).then(([respData]) => setData(respData))
    } else {
      Promise.all([getCargo()]).then(([cargo]) => {
        if (cargo != null && cargo.manifestId) {
          Promise.all([fetchManifestResponse(cargo.manifestId)]).then(([respData]) => setData(respData))
        }
      })
    }
  }

  useEffect(() => {
    showManifestResponse();
    Promise.all([
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [
          {
            field: 'codeType',
            operator: EQUAL,
            value: 'ACI_HW_SUBMISSION_TYPE'
          }
        ],
        undefined,
        'code'
      ),
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACIHWY_STATUS' }],
        undefined,
        'code'
      )
    ]).then(([submissionType, status]) => {
      setLookups({ submissionType, status })
    })
  }, [])

  const columns = [
    {
      field: 'batchId',
      title: aciHighwayManifestTranslationText.responseId
    },
    {
      field: 'receivedDate',
      title: aciHighwayManifestTranslationText.responseDate,
      render: (data) =>
        data.receivedDate &&
        moment(data.receivedDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
    },
    {
      field: 'tripNo',
      title: aciHighwayManifestTranslationText.tripNo,
      render: (data) => data.tripNo
    },
    {
      field: 'errorCode',
      title: aciHighwayManifestTranslationText.responseCode,
      render: (data) => (
        <Grid container spacing={1}>
          {data.errorResponses.map((response, index) => (
            <Grid key={index} item xs={12}>
              <Typography variant='body2'>{response.errorCode}</Typography>
              {/* <Typography color='textSecondary' variant='caption'>
                {response.remarks}
              </Typography> */}
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      field: 'responseText',
      title: aciHighwayManifestTranslationText.responseText,
      render: (data) => (
        <Grid container spacing={1}>
          {data.errorResponses.map((response, index) => (
            <Grid key={index} item xs={12}>
              <Typography variant='body2'>{response.responseText}</Typography>
            </Grid>
          ))}
        </Grid>
      )
    },
    {
      title: aciHighwayManifestTranslationText.submissionType,
      render: (data) =>
        lookups
          ? lookups['submissionType'][data.submissionType]
          : data.submissionType
    },
    {
      field: 'status',
      title: aciHighwayManifestTranslationText.status,
      render: (data) => (lookups ? lookups['status'][data.status] : data.status)
    },

    {
      title: aciHighwayManifestTranslationText.cbsaResponseDate,
      render: (data) =>
        data.cbsaProcessingDate &&
        moment(data.cbsaProcessingDate).tz("Canada/Eastern").format('D MMM YYYY HH:mm')
    },
    {
      field: 'submitId',
      title: aciHighwayManifestTranslationText.submitId,
      render: (data) => data.submitId
    },
    { field: 'methodOfSubmission',
    title: aciHighwayManifestTranslationText.methodOfSubmission,
    render: (data) => data.methodOfSubmission } 
  ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    setPage(0)
  }

  return (
    <>
      <TableContainer>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((d) => (
                  <TableRow key={d.id}>
                    {columns.map((column, index) => (
                      <TableCell key={index}>
                        {column.render ? column.render(d) : d[column.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell align='center' colSpan={columns.length}>
                  <Typography variant='body2' color='textSecondary'>
                    {aciHighwayManifestTranslationText.noRecordsToDisplay}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
        component='div'
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage={aciHighwayManifestTranslationText.rowPerPageLabel}
      />
    </>
  )
}

export default ManifestResponse
